
export default function ERR403() {
    return (
        <>
            You Are Not Auth For This Page
        </>
    )
}